import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { apiFetch } from 'api/client';
import { Field, FormAlert } from './AuthentikLoginForm';

export { LocalLoginForm };

const validationSchema = Yup.object().shape({
    username: Yup.string().required('Username is required'),
    password: Yup.string().required('Password is required'),
});

// Legacy sign-in with a stats-api local account (username + password).
function LocalLoginForm({ onAuthenticated, primary = false }) {
    const [authError, setAuthError] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const { register, handleSubmit, formState } = useForm({ resolver: yupResolver(validationSchema) });
    const { errors, isSubmitting } = formState;

    async function onSubmit({ username, password }) {
        setAuthError(null);
        try {
            const response = await apiFetch('/authenticate', {
                method: 'POST',
                json: { username, password, browser_session: true },
                skipSessionCheck: true,
            });

            if (!response.ok) {
                throw new Error('Invalid username or password');
            }

            onAuthenticated(await response.json());
        } catch (error) {
            setAuthError(error.message);
        }
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="login-flow" noValidate>
            <Field id="username" label="Username" icon="person" errors={errors.username ? [errors.username.message] : []}>
                <input
                    id="username"
                    type="text"
                    autoComplete="username"
                    autoCapitalize="none"
                    spellCheck="false"
                    {...register('username')}
                    className="login-input"
                    aria-invalid={Boolean(errors.username)}
                />
            </Field>

            <Field id="password" label="Password" icon="lock" errors={errors.password ? [errors.password.message] : []}>
                <input
                    id="password"
                    type={showPassword ? 'text' : 'password'}
                    autoComplete="current-password"
                    {...register('password')}
                    className="login-input login-input-with-action"
                    aria-invalid={Boolean(errors.password)}
                />
                <button
                    type="button"
                    className="login-input-action"
                    onClick={() => setShowPassword((value) => !value)}
                    aria-label={showPassword ? 'Hide password' : 'Show password'}
                    aria-pressed={showPassword}
                >
                    <span className="material-symbols-outlined" aria-hidden="true">
                        {showPassword ? 'visibility' : 'visibility_off'}
                    </span>
                </button>
            </Field>

            {authError && <FormAlert message={authError} />}

            <button
                type="submit"
                disabled={isSubmitting}
                className={`login-btn ${primary ? 'login-btn-primary' : 'login-btn-secondary'}`}
            >
                {isSubmitting
                    ? <span className="login-spinner" aria-hidden="true"></span>
                    : <span className="material-symbols-outlined" aria-hidden="true">login</span>}
                Sign in with local account
            </button>
        </form>
    );
}
